/* Mushy · Bewertungsliste
   Zwei Aufgaben: Karten nachladen und lange Texte kappen.

   Der Weiterlesen-Knopf wird gemessen, nicht geraten: versteckte Karten haben
   Hoehe 0 und wuerden sonst nie einen bekommen. Deshalb nach jedem Nachladen
   und nach dem Laden der Schriften erneut messen. */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function clamp(root) {
    (root || document).querySelectorAll('.mu-review-list [data-clamp]').forEach(function (p) {
      if (p.muCheck) {
        p.muCheck();
        return;
      }

      p.classList.add('is-cut');

      var more = p.dataset.more || 'Weiterlesen';
      var less = p.dataset.less || 'Weniger';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mu-review-list__readmore';
      btn.textContent = more;
      p.after(btn);

      var check = function () {
        if (!p.classList.contains('is-cut')) return;
        btn.classList.toggle('is-on', p.scrollHeight - p.clientHeight > 4);
      };

      btn.addEventListener('click', function () {
        var cut = p.classList.toggle('is-cut');
        btn.textContent = cut ? more : less;
      });

      p.muCheck = check;
      check();
      window.addEventListener('resize', check);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-review-list]').forEach(function (list) {
      if (list.dataset.ready) return;
      list.dataset.ready = '1';

      var wrap = list.closest('.mu-review-list');
      var shown = wrap.querySelector('[data-review-shown]');
      var count = wrap.querySelector('[data-review-count]');
      var step = parseInt(list.dataset.step, 10) || 3;
      var btns = wrap.querySelectorAll('[data-review-more]');
      // Stehen von Anfang an alle Karten offen, ist nichts nachzuladen: dann
      // bleibt der Zaehler, wie er im Template steht. Sonst wuerde eine Liste
      // mit sieben von 216.418 Bewertungen behaupten, es seien alle.
      var hasHidden = !!list.querySelector('.mu-review-list__card[hidden]');

      var sync = function () {
        var visible = list.querySelectorAll('.mu-review-list__card:not([hidden])').length;
        if (shown) shown.textContent = visible;
        if (hasHidden && !list.querySelector('.mu-review-list__card[hidden]')) {
          btns.forEach(function (b) {
            var w = b.closest('.mu-review-list__more-wrap');
            (w || b).hidden = true;
          });
          if (count && list.dataset.allLabel) count.textContent = list.dataset.allLabel;
        }
      };

      btns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var fresh = Array.prototype.slice.call(
            list.querySelectorAll('.mu-review-list__card[hidden]'), 0, step
          );
          fresh.forEach(function (el) { el.hidden = false; });
          clamp(list);
          if (fresh[0]) {
            fresh[0].setAttribute('tabindex', '-1');
            fresh[0].focus({ preventScroll: true });
          }
          sync();
        });
      });

      sync();
    });

    clamp(root);
  }

  ready(function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
